<template>
  <div class="calico-billing-item">
    <div class="row">
      <!-- Amount -->
      <div class="amount label--small">
        {{ formattedAmount }}
      </div>

      <!-- Billing Date -->
      <div class="date label--xsmall">
        {{ formattedDate }}
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, formatDisplayDate } from '@/utils/helper';

export default {
  name: "CalicoBillingItem",

  props: {
    amount: {
      type: Number,
      required: true
    },

    currency: {
      type: String,
      default: "USD"
    },

    date: {
      type: [String, Date],
      required: true
    }
  },

  computed: {
    formattedAmount() {
      return formatCurrency(this.amount, this.currency, 'en-US', true)
    },
    formattedDate() {
      return formatDisplayDate(this.date)
    }
  }
};
</script>
<style scoped lang="scss">
.calico-billing-item {
  border-bottom: 1px solid $color-neutral-light;

  .row {
    @include inline-space($space-small);
    @include inset-space($space-small);

    align-items: center;
    width: 100%;
  }

  .amount {
    min-width: 166px;
    flex: 1;
    align-self: stretch;
    white-space: nowrap;
    color: $color-black;
  }

  .date {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>